// the corner plate: every display's stock logo image becomes the Russian Hill Local plate in the cable-car livery
import { escapeHtml } from '../utils/string.mjs';

const { brand } = window.RHL;

const applyPalette = () => {
	const root = document.documentElement.style;
	root.setProperty('--rhl-plate-top', brand.plate.top);
	root.setProperty('--rhl-plate-bottom', brand.plate.bottom);
	root.setProperty('--rhl-plate-border', brand.plate.border);
	root.setProperty('--rhl-plate-text', brand.plate.text);
	root.setProperty('--rhl-ticker-rule', brand.tickerRule);
};

const swapPlates = () => {
	const lines = brand.plate.lines.map(escapeHtml).join('<br>');
	document.querySelectorAll('.header .logo').forEach((logo) => {
		const plate = document.createElement('div');
		plate.className = 'rhl-plate';
		plate.innerHTML = lines;
		logo.replaceChildren(plate);
	});

	// the title card shown before the first forecast loads
	const loadingTitle = document.querySelector('#loading .title');
	if (loadingTitle) loadingTitle.textContent = brand.name;
	document.title = brand.name;
};

applyPalette();
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', swapPlates);
} else {
	swapPlates();
}
